"use client";

import { AiOutlineMenu } from "react-icons/ai";
import { FaUserCircle } from "react-icons/fa";
import { BiUserCircle } from "react-icons/bi";
import { signOut, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import MenuItem from "./MenuItem";

interface UserMenuProps {
  isOpen: boolean;
  toggleOpen: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ isOpen, toggleOpen }) => {
  const router = useRouter();
  const { data: session } = useSession();

  const handleMenuItemClick = (action: () => void) => {
    action();
    toggleOpen();
  };

  const menuItems = session?.user
    ? [
      ...(session.user.role === "ADMIN"
        ? [
          { label: "Purchases", path: "/adm/count" },
          { label: "Referrals", path: "/adm/referrals" },
          { label: "Payments Referrals", path: "/adm/payments" },
          { label: "Coupons", path: "/adm/coupons" },
          { label: "emails", path: "/adm/test-email" },
        ]
        : []),
      { label: "Affiliates Dashboard", path: `/affiliates-dashboard/${session.user.id}` },
      { label: "Logout", onClick: () => signOut({ callbackUrl: process.env.NEXTAUTH_URL }) },
    ]
    : [
      { label: "Login", path: "/login" },
      { label: "Sign up", path: "/register" },
    ];

  return (
    <div className="relative">
      <div className="flex flex-row items-center gap-3">
        <div
          onClick={toggleOpen}
          className="
            p-2 md:py-2 md:px-3 border-[1px] 
            border-gray-600 flex flex-row items-center 
            gap-3 rounded-lg cursor-pointer 
            hover:shadow-md hover:border-cyan-400 transition
            bg-gray-800 
          "
        >
          {session?.user ? (
            <FaUserCircle size={20} className="text-white" />
          ) : (
            <BiUserCircle size={20} className="text-white" />
          )}
          <div className="hidden md:block text-sm text-white">
            {session?.user?.name || "Admin"}
          </div>
          {/* <div className="sm:hidden">
            <AiOutlineMenu size={20} className="text-white" />
          </div> */}
        </div>
      </div>
      {isOpen && (
        <div
          className="
            absolute z-50 rounded-xl shadow-md w-[90vw] sm:w-[70vw] md:w-[50vw] lg:w-[30vw] 
            bg-gray-800 border border-gray-600 overflow-hidden right-0 top-12 text-sm
          "
        >
          <div className="flex flex-col cursor-pointer">
            {menuItems.map((item, index) => (
              <div key={index}>
                {item.label === "Logout" && (
                  <hr className="border-t border-gray-600" />
                )}
                <MenuItem
                  label={item.label}
                  onClick={() =>
                    handleMenuItemClick(
                      item.onClick
                        ? item.onClick
                        : () => router.push(item.path!),
                    )
                  }
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;